"use strict";
import { useCallback, useMemo } from "react";
import { setCloseModal, setOpenModal } from "state/application/reducer";
import { useAppDispatch, useAppSelector } from "state/hooks";
export function useModalState(modalName) {
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector((state) => state.application.openModal?.name === modalName);
  const openModal = useCallback(() => {
    dispatch(setOpenModal({ name: modalName }));
  }, [dispatch, modalName]);
  const closeModal = useCallback(() => {
    dispatch(setCloseModal(modalName));
  }, [dispatch, modalName]);
  const toggleModal = useCallback(() => {
    if (isOpen) {
      closeModal();
    } else {
      openModal();
    }
  }, [isOpen, openModal, closeModal]);
  const modalState = useMemo(
    () => ({
      isOpen,
      openModal,
      closeModal,
      onClose: closeModal,
      toggleModal
    }),
    [isOpen, openModal, closeModal, toggleModal]
  );
  return modalState;
}
